<template>
  <v-menu
    offset-y
    location="bottom end"
    :close-on-content-click="false">
    <template #activator="{ props }">
      <v-btn
        v-bind="props"
        icon
        variant="text"
        class="position-relative"
        @click.prevent
      >
        <v-icon class="mx-2" color="#B1B7C1" icon="mdi-bell" />
        
        <template v-if="notifMsg.filter(msg => !msg.read).length !== 0">
          <span
            class="position-absolute top-1 start-75 translate-middle badge rounded-pill bg-error"
            style="font-size: 0.625em;"
          >
            <small v-if="notifMsg.length < 100">{{ notifMsg.filter(msg => !msg.read).length ?? 0 }}</small>
            <small v-else>99+</small>
          </span>
        </template>
      </v-btn>
    </template>

    <v-card class="notification-dropdown" max-width="400" elevation="2">
      <v-list density="comfortable">
        <v-list-item v-if="notifMsg.length === 0" class="py-6">
          <v-list-item-title class="text-center text-medium-emphasis">
            {{ langKey.labelNoNotifications ?? 'No notifications' }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-else
          v-for="(item, index) in notifMsg"
          :key="index"
          class="notification-listgroupitem-highlight"
        >
          <v-row class="align-center" no-gutters>
            <v-col cols="auto">
              <v-icon
                class="me-3"
                size="large"
                :icon="{
                  info: 'mdi-information-variant',
                  warning: 'mdi-bell-exclamation',
                  alert: 'mdi-alert'
                }[item.type] || 'mdi-bell'"
              />
            </v-col>

            <v-col>
              <div
                @click.stop="showHideCollapsible(item)"
                title="Click to expand/collapse this notification"
                class="cursor-pointer"
              >
                <div style="font-size: 0.75em;">{{ item.time }}</div>
                <div class="d-flex align-center">
                  <div class="me-auto">
                    <strong v-if="!item.read">
                      {{ item.title }} [{{ langKey.labelNewNotification }}]
                    </strong>
                    <span v-else>{{ item.title }}</span>
                  </div>
                  <v-icon size="small" class="ms-2">
                    {{ item.visible ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                  </v-icon>
                </div>
              </div>

              <v-expand-transition>
                <div v-show="item.visible">
                  <v-card
                    class="mt-2"
                    variant="outlined"
                    @click.stop="setRead(item)"
                    title="Click to mark as read"
                  >
                    <v-card-text style="color: rgba(44, 56, 74, 0.95);">
                      <p class="m-0"><strong>{{ langKey.labelNewNotificationMessage }}:</strong></p>
                      <p class="m-0">{{ item.message }}</p>
                    </v-card-text>
                  </v-card>
                </div>
              </v-expand-transition>
            </v-col>
          </v-row>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import iStoreNotifService from '@/scripts/istore-push-notif'

export default {
  name: 'AppHeaderDropdownNotif',
  data() {
    return {
      notifMsg: iStoreNotifService.data.notifications,
      dropdownVisible: false
    }
  },
  created() {
    window.AppHeaderDropdownNotif = this
  },
  methods: {
    setRead(item) {
      iStoreNotifService.markAsRead(item)
      item.visible = false
    },
    showHideCollapsible(item) {
      item.visible = !item.visible
    }
  },
}
</script>
